import { gql } from '@apollo/client';
export const AUTH_QUERIES = {
SEND_OTP : gql`
mutation SendOTP($phone: String!, $entityType: String!, $transactionType: String!) {
  sendOTP(phone: $phone, entityType: $entityType, transactionType: $transactionType) {
    success
    message
    transactionId
  }
}`,
RESEND_OTP : gql`
    mutation ResendOTP($phone: String!, $entityType: String!, $transactionType: String!) {
      resendOTP(phone: $phone, entityType: $entityType, transactionType: $transactionType) {
        success
        message
        transactionId
      }
    }
`,
VERIFY_PHONE_OTP : gql`
mutation VerifyPhoneOTP($phone: String!, $otp: String!, $transactionId: ID!, $entityType: String!) {
  verifyPhoneOTP(phone: $phone, otp: $otp, transactionId: $transactionId, entityType: $entityType) {
    success
    message
  }
}`,

} as const;
